import { Button, DialogHeader, Heading } from "@chakra-ui/react";
import React, { useEffect } from "react";
import type { JSX } from "react";

import { DialogBody, DialogCloseTrigger, DialogContent, DialogFooter, DialogRoot } from "../ui/dialog";

export const ChackraUIBaseModal = (props: {
  open: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  unclosable?: boolean;
  submitButton?: boolean;
  footerCloseButton?: boolean;
  submitButtonText?: string;
  title: string | JSX.Element;
  body: JSX.Element;
  blurredOverlay?: boolean;
  size: "sm" | "md" | "lg" | "xl" | "xs" | "cover" | "full";
  submitButtonDisabled?: boolean;
}) => {
  const executeSubmit = () => {
    if (props.onSubmit) props.onSubmit();
    if (props.onClose) props.onClose();
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape" && props.open && props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line
  }, [props.open]);

  let submitSegment = <></>;
  let footerCloseButton = <></>;

  if (props.submitButton) {
    submitSegment = (
      <Button
        mr={3}
        onClick={() => {
          executeSubmit();
        }}
        disabled={props.submitButtonDisabled}
      >
        {props.submitButtonText}
      </Button>
    );
  }

  if (props.footerCloseButton) {
    footerCloseButton = (
      <Button colorPalette="error" mr={3} onClick={props.onClose}>
        Close
      </Button>
    );
  }

  return (
    <>
      <DialogRoot open={props.open} size={props.size}>
        <DialogContent>
          <DialogHeader asChild>
            <Heading size={"xl"}>{props.title}</Heading>
          </DialogHeader>
          {props.unclosable ? null : <DialogCloseTrigger onClick={props.onClose} />}
          <DialogBody>{props.body}</DialogBody>
          <DialogFooter>
            {submitSegment}
            {footerCloseButton}
          </DialogFooter>
        </DialogContent>
      </DialogRoot>
    </>
  );
};
